module.exports = __webpack_public_path__ + "img/empezar.1691b724.svg";